import { cloneDeep, isEmpty, pickBy } from "lodash";
import { apiSlice } from "./apiSlice";
import store from "src/_store/store"
import { ROLES, USER_ROLES } from "src/constants";

const getURLPath = (xls) => {
    try {
        const state = store.getState()
        let profile = state.entities.profile.profile
        if (profile?.role === ROLES.freelanceDriver) {
            if (xls) return ''
            return "/driver"
        } else if ([ROLES.shippingCompany, ROLES.merchant, USER_ROLES.MERCHANT].includes(profile?.merchant?.role)) {
            if (profile?.merchant?.shippingType === "FIRST_MILE" || xls) {
                return ''
            }
            return "/shipping-company"
        }
    } catch (error) {
        console.log("error")
        console.log(error)
    }
}

const getGlobalFilterCriteria = (params, warehouseTypeArray = false) => {
    const state = store.getState()
    let customizations = cloneDeep(state?.entities?.customizations)
    let customizationsExistedData = pickBy(customizations, v => !isEmpty(v))
    if (!isEmpty(customizationsExistedData)) {
        if (!!customizationsExistedData?.warehouse) {
            if (warehouseTypeArray) {
                customizationsExistedData.warehouse = [customizationsExistedData?.warehouse?.id]
            } else {
                customizationsExistedData.warehouse = customizationsExistedData?.warehouse?.id
            }
        }
        return { ...params, ...customizationsExistedData }
    }
    return params
}

export const taskApi = apiSlice
    .enhanceEndpoints({ addTagTypes: ['ORDER'] })
    .injectEndpoints({
        keepUnusedDataFor: 1,
        endpoints: builder => ({
            getTasks: builder.query({
                query: (params) => {
                    return {
                        url: '/task',
                        method: 'GET',
                        params: getGlobalFilterCriteria(params)
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getTasksCountByZone: builder.query({
                query: (params) => ({
                    url: '/task/tasks_count_by_zone',
                    method: 'GET',
                    params: getGlobalFilterCriteria(params)
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getTasksByZone: builder.query({
                query: (params) => ({
                    url: '/task/tasks_by_zone',
                    method: 'GET',
                    params: getGlobalFilterCriteria(params)
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getTasksByFilter: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/filter`,
                        method: 'POST',
                        body: { ...getGlobalFilterCriteria(payload, true) }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getTaskById: builder.query({
                query: (id) => ({
                    url: `/task/${id}`,
                    method: 'GET',
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createTask: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task${getURLPath()}/create`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createTaskByXls: builder.mutation({
                query: (payload) => {
                    let xls = payload?.xls ?? false
                    delete payload?.xls
                    return {
                        url: `/task${getURLPath(xls)}/xls`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createTaskExternal: builder.mutation({
                query: ({ payload, path }) => {
                    let id = payload?.id
                    delete payload?.id
                    return {
                        url: `/task${path}/external/create/${id}`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createDropOffTask: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/create-dropoff-task`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createReturnTask: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/create-return-task`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createTransferTask: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/create-transfer-task`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createTaskByXlsExternal: builder.mutation({
                query: ({ payload, path }) => {
                    return {
                        url: `/task${path}/external/xls`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            assignDriverToTask: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/assign-driver`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            assignDriverToMultiTasks: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/assign-driver-to-tasks`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            assignDriverToZones: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/assign-driver-to-tasks-by-zones`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createDropoffTaskByAssignDriverToZones: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/create-dropoff-task-by-zones`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            updateTaskStatus: builder.mutation({
                query: ({ taskId, payload }) => {
                    return {
                        url: `/task/update_status/${taskId}`,
                        method: 'PUT',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            updateTask: builder.mutation({
                query: ({ taskId, payload }) => {
                    return {
                        url: `/task/${taskId}`,
                        method: 'PUT',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            updateTaskOrdersManually: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/add-orders`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            updateTaskOrdersXls: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/add-orders-by-xls`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            removeOrdersFromTask: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/remove-orders`,
                        method: 'DELETE',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getReturnedTasks: builder.query({
                query: (params) => ({
                    url: '/task/returns',
                    method: 'GET',
                    params: getGlobalFilterCriteria(params)
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createTaskForSelectedOrders: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/create_by_orders`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            tasksFilter: builder.query({
                query: (params) => {
                    // if (!!params?.page) {
                    //     payload.page = payload.page + ''
                    // }
                    // if (!!payload?.limit) {
                    //     payload.limit = payload.limit + ''
                    // }
                    return {
                        url: `/task/filter`,
                        method: 'GET',
                        params
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getWarehousesTasksCount: builder.query({
                query: (params) => ({
                    url: '/task/warehouse_tasks_count',
                    method: 'GET',
                    params: getGlobalFilterCriteria(params)
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getWarehouseTasksById: builder.query({
                query: ({ warehouseId, params }) => ({
                    url: `/task/warehouse_tasks/${warehouseId}`,
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            updateDriverToTasks: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/update-driver`,
                        method: 'PUT',
                        body: { ...payload }
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createTaskForUnassignedOrders: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/create_by_orders_shipping_company`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getTaskZoneHistory: builder.query({
                query: (taskId) => {
                    return {
                        url: `/task/zone-history/${taskId}`,
                        method: 'GET',
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getTaskStatusHistory: builder.query({
                query: (taskId) => {
                    return {
                        url: `/task/status-track/${taskId}`,
                        method: 'GET',
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createReturnTaskByMerchant: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/merchant/create-return`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createReturnTaskForCustomerByDriver: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/create-user-return-task`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                invalidatesTags: (_, __, { orderId }) => [
                    { type: 'ORDER', id: orderId },
                    { type: 'ORDER', id: 'ORDER-PARTIAL-LIST' },
                ],
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createReturnTaskForCustomerByShippingCompany: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/merchant/create-user-return-task`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                invalidatesTags: (_, __, { orderId }) => [
                    { type: 'ORDER', id: orderId },
                    { type: 'ORDER', id: 'ORDER-PARTIAL-LIST' },
                ],
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createReturnTaskForUnRegisteredMerchant: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/task/not-register/create-return-task`,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getTasksExcel: builder.query({
                query: ({ params, email }) => {
                    return {
                        url: `/task/excel/${email}`,
                        method: 'GET',
                        params
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getTasksList: builder.query({
                query: (params) => {
                    return {
                        url: '/task/list',
                        method: 'GET',
                        params
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getConnectionTasksList: builder.query({
                query: ({ params, shippingCompanyId }) => {
                    return {
                        url: `/task/connection/${shippingCompanyId}`,
                        method: 'GET',
                        params
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedTasks: builder.query({
                query: (params) => {
                    return {
                        url: `/archived-task/filter`,
                        method: 'GET',
                        params
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedTasksXls: builder.query({
                query: ({ params, email }) => {
                    return {
                        url: `/archived-task/excel/${email}`,
                        method: 'GET',
                        params
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedTaskById: builder.query({
                query: (id) => ({
                    url: `/archived-task/${id}`,
                    method: 'GET',
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedTaskZoneHistory: builder.query({
                query: (taskId) => {
                    return {
                        url: `/archived-task/zone-history/${taskId}`,
                        method: 'GET',
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedTaskStatusHistory: builder.query({
                query: (taskId) => {
                    return {
                        url: `/archived-task/status-track/${taskId}`,
                        method: 'GET',
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
        })
    })

export const {
    useGetTasksQuery,
    useLazyGetTasksQuery,
    useGetTasksCountByZoneQuery,
    useLazyGetTasksCountByZoneQuery,
    useGetTasksByZoneQuery,
    useCreateTaskMutation,
    useCreateTaskByXlsMutation,
    useCreateTaskExternalMutation,
    useCreateTaskByXlsExternalMutation,
    useGetTaskByIdQuery,
    useGetTasksByFilterMutation,
    useCreateDropOffTaskMutation,
    useCreateTransferTaskMutation,
    useAssignDriverToTaskMutation,
    useAssignDriverToMultiTasksMutation,
    useAssignDriverToZonesMutation,
    useUpdateTaskStatusMutation,
    useUpdateTaskMutation,
    useUpdateTaskOrdersManuallyMutation,
    useUpdateTaskOrdersXlsMutation,
    useRemoveOrdersFromTaskMutation,
    useGetReturnedTasksQuery,
    useCreateDropoffTaskByAssignDriverToZonesMutation,
    useCreateTaskForSelectedOrdersMutation,
    useLazyTasksFilterQuery,
    useLazyGetWarehousesTasksCountQuery,
    useGetWarehouseTasksByIdQuery,
    useUpdateDriverToTasksMutation,
    useCreateTaskForUnassignedOrdersMutation,
    useCreateReturnTaskMutation,
    useLazyGetTaskZoneHistoryQuery,
    useGetTaskStatusHistoryQuery,
    useCreateReturnTaskByMerchantMutation,
    useCreateReturnTaskForCustomerByDriverMutation,
    useCreateReturnTaskForCustomerByShippingCompanyMutation,
    useCreateReturnTaskForUnRegisteredMerchantMutation,
    useLazyGetTasksExcelQuery,
    useGetTasksListQuery,
    useGetConnectionTasksListQuery,
    useLazyGetArchivedTasksQuery,
    useLazyGetArchivedTasksXlsQuery,
    useGetArchivedTaskByIdQuery,
    useLazyGetArchivedTaskZoneHistoryQuery,
    useGetArchivedTaskStatusHistoryQuery,
} = taskApi